export const courseContentReviewRoutesDefinitions = {
  contentReview: {
    path: 'content-review',
    name: 'courseContentReview'
  },
  contentOverview: {
    path: 'content-review/:projectId',
    name: 'courseContentOverview'
  },
  reviewContent: {
    path: 'content-review/:projectId/review',
    name: 'courseContentReviewContent'
  },
  kfkReport: {
    path: 'content-review/:projectId/:courseVersionId/kfk-report/:publishingJobId',
    name: 'courseContentKfkReport'
  },
  publishedVideos: {
    path: 'content-review/:projectId/published-videos',
    name: 'courseContentPublishedVideos'
  },
  homeInitFailed: {
    path: 'init-failed',
    name: 'courseContentReviewInitFailed'
  },
  manageUserAccess: {
    path: 'content-review/manage-user-access',
    name: 'courseContentReviewManageUserAccess'
  }
};
